import { render, staticRenderFns } from "./EventOccurrenceTemplate.vue?vue&type=template&id=f28b9044&"
import script from "./EventOccurrenceTemplate.vue?vue&type=script&lang=js&"
export * from "./EventOccurrenceTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EventOccurrenceTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports